import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@cloudox/api-client";
import { LoadingState } from "@cloudox/ui";

/** Handles the Cognito hosted-UI redirect: exchanges the code for tokens, then
 * sends the user back to the home page. */
export function AuthCallbackPage() {
  const { completeLogin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    void completeLogin().finally(() => {
      if (active) navigate("/", { replace: true });
    });
    return () => {
      active = false;
    };
  }, [completeLogin, navigate]);

  return <LoadingState label="Signing you in…" />;
}
